<template>
  <div class="system_admin">
    <!-- VIP配置 -->
    <el-form>
      <el-row>
        <el-input
          v-model.trim="queryData.model.id"
          style="width: 200px; margin: 0 0 0 10px"
          placeholder="搜索"
          clearable
          @clear="clear"
        />
        <el-button
          type="primary"
          class="search"
          style="margin: 0 0 0 10px"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          class="search"
          style="margin: 0 0 0 10px"
          @click="add_click"
        >添加</el-button>
      </el-row>
    </el-form>

    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
    >
      <!-- <el-table-column prop="id" label="id"> </el-table-column> -->
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="inviteUserCount" label="邀请人数" />
      <!-- <el-table-column prop="investAmountPerPerson" label="每人充值金额"> </el-table-column> -->
      <el-table-column prop="investAmountPerPerson" label="每人投资金额" />
      <!-- <el-table-column prop="rechareAmount" label="充值金额"> </el-table-column> -->
      <el-table-column
        prop="improveRate"
        label="收益提升率,1=1%"
      />
      <el-table-column
        prop="cashAward"
        label="实际奖励"
      />
      <el-table-column
        prop="showAward"
        label="展示奖励"
      />

      <!-- <el-table-column prop="logo" label="图片">
        <template slot-scope="scope">
          <el-popover placement="top-start" title="" trigger="hover">
            <img
              :src="scope.row.logo"
              alt=""
              style="width: 240px; height: 150px"
            />
            <img
              slot="reference"
              :src="scope.row.logo"
              style="width: 50px; height: 30px"
            />
          </el-popover>
        </template>

      </el-table-column> -->
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column prop="updateTime" label="更新时间" />
      <el-table-column label="操作" width="235">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleEdit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="blank" />

    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNo"
      :page-sizes="[15, 30, 50, 100, 200]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="40%">
      <el-form :model="rechargeForm" label-width="110px">
        <el-form-item label="名称:">
          <el-input
            v-model.trim="rechargeForm.name"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <el-form-item label="邀请人数:">
          <el-input
            v-model.trim="rechargeForm.inviteUserCount"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <el-form-item label="会员等级:">
          <el-input
            v-model.trim="rechargeForm.level"
            type="number"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <!-- <el-form-item label="每人投资金额:">
          <el-input
            v-model.trim="rechargeForm.investAmountPerPerson"
            autocomplete="off"
            class="rechargeFormInput"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="每人充值金额:">
          <el-input
            v-model.trim="rechargeForm.investAmountPerPerson"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <el-form-item label="提升收益率:">
          <el-input
            v-model.trim="rechargeForm.improveRate"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <el-form-item label="实际奖励:">
          <el-input
            v-model.trim="rechargeForm.cashAward"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <el-form-item label="展示奖励:">
          <el-input
            v-model.trim="rechargeForm.showAward"
            autocomplete="off"
            class="rechargeFormInput"
          />
        </el-form-item>
        <!-- <el-form-item label="图片:">
          <el-upload
            class="upload-demo"
            drag
            action="#"
            accept=".jpeg, .png, .jpg"
            :before-upload="beforeFile"
            :limit="1"
          >
            <img v-if="url" :src="url" alt="" class="pica" />
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel"
          @click="dialogFormVisible = false"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="dialogFormVisibleClk"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post, get } from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'
const moment = require('moment')
import sha256 from 'crypto-js/sha256'

export default {
  name: 'VipConfig',

  data() {
    return {
      queryData: {
        pageSize: 15,
        pageNo: 1,
        model: {
          id: ''
        }
      },
      total: 0,
      dialogFormVisible: false,
      rechargeForm: {
        name: '',
        level: '',
        inviteUserCount: '',
        // rechareAmount: "",
        improveRate: '',
        cashAward: '', // 实际奖励
        showAward: '', // 展示奖励
        id: '',
        investAmountPerPerson: '',
        inviteUserCount: ''
      },
      title: '',
      url: '',
      tableData: []
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    clear() {
      this.getListData()
    },
    search() {
      this.getListData()
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          post('/admin/ope/vipconfig/delete', { id: row.id }).then((res) => {
            if (res.data.code == 20000) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getListData()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 上传图片
    beforeFile(file) {
      const formData = new FormData()
      formData.append('multipartFile', file)
      const token = getToken()
      const _this = this
      const timestamp = Date.now()
      const sign = '213z@W!X#$%&'
      axios
        .post('https://api.maerskwork.com/hub/file/upload', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-timestamp': timestamp,
            'X-sign': sha256(sign + JSON.stringify(formData || {}) + timestamp)
          }
        })
        .then(function(res) {
          _this.url = res.data.data.data
          _this.fileList.push({ url })
        })
        .catch(function(error) {})
    },
    add_click() {
      this.rechargeForm = {}
      this.url = ''
      this.title = '添加'
      this.dialogFormVisible = true
    },
    handleEdit(row) {
      this.title = '编辑'
      this.dialogFormVisible = true
      this.rechargeForm.id = row.id
      post('/admin/ope/vipconfig/get', { id: row.id }).then((res) => {
        this.rechargeForm = res.data.data
        this.url = res.data.data.logo
      })
    },
    dialogFormVisibleClk() {
      this.dialogFormVisible = false
      this.rechargeForm.logo = this.url
      if (this.title == '添加') {
        post('/admin/ope/vipconfig/add', this.rechargeForm).then((res) => {
          if (res.data.code == 20000) {
            this.$message({
              type: 'success',
              message: this.title + '成功'
            })
            this.getListData()
          }
        })
      } else {
        post('/admin/ope/vipconfig/update', this.rechargeForm).then((res) => {
          if (res.data.code == 20000) {
            this.$message({
              type: 'success',
              message: this.title + '成功'
            })
            this.getListData()
          }
        })
      }
    },
    getListData() {
      post('/admin/ope/vipconfig/page', this.queryData).then((res) => {
        this.total = res.data.data.total
        this.tableData = res.data.data.data
      })
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val
      this.getListData()
    },
    handleCurrentChange(val) {
      this.queryData.pageNo = val
      this.getListData()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-upload-dragger {
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
